module.exports = slugOrTitle =>
  slugOrTitle
    .replace(/['’ʻ]/g, ``)
    .split(/[^a-zA-Z]/gm)
    .filter(x => x.length)
    .join(`-`)
    .toLowerCase()
